import { QUERY_KEYS } from "@/libraries/constant";
import { authService } from "@/services";
import type { QueryClient } from "@tanstack/react-query";

const registerMember = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_AUTH_REGISTER], {
		mutationFn: authService.register.bind(authService),
	});
};

const authLogin = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_AUTH_LOGIN], {
		mutationFn: authService.login.bind(authService),
	});
};

const authLoginSso = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_AUTH_LOGIN_SSO], {
		mutationFn: authService.ssoLogin.bind(authService),
		retry: 2,
	});
};

export const authMutations = (queryClient: QueryClient) => {
	registerMember(queryClient);
	authLogin(queryClient);
	authLoginSso(queryClient);
};
